import HelperIcon from "components/HelperIcon/HelperIcon";
import ClientModal from "custom_modules/WorkOrderNew/CreateWorkOrder/ClientModal";
import moment from "moment";
import "moment-timezone";
import queryString from "query-string";
import { Fragment, useEffect, useRef, useState } from "react";

import crossIcon from "../../../assets/img/icons/cross_black.svg";
import Plus from "../../../assets/img/icons/plus.svg";
import reorder from "../../../assets/img/reorder.svg";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import ProjectDropdown from "../../../components/CommonFilter/ProjectDropdown";
import DotLoader from "../../../components/DropdownLoader/DropdownLoader";
import CreateProjectDropdown from "../../../components/DropdownStyle/CreateProjectDropdown";
import ButtonTextLoader from "../../../components/Loaders/ButtonTextLoader";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import Select from "../../../components/ReactSelectDropdown";
import DatePicker from "../../../components/SingleDatePicker/SingleDatePicker";
import InfoTooltip from "../../../components/Tooltip/InfoTooltip";
import {
  ColoredButton,
  ColoredButtonWithIcon,
  PrimaryBgButton,
  PrimaryButton,
  PrimaryWhiteBgButton,
  WhiteButton,
} from "../../../styledComponents/buttons";
import {
  CardTitle,
  ColoredText,
  CommonGrid,
  CommonText,
  Container,
  ContainerNew,
  InputField,
  InputLabel,
  InputWithLabelSection,
  PageTitle,
  RedStar,
  TableText,
} from "../../../styledComponents/common";
import {
  BillingQues,
  BillingTooltip,
  BillingTooltipText,
  Cross,
  CrossIcon,
  FormAlert,
  GeneralDetailsInputContainer,
} from "../../../styledComponents/createProject";
import {
  AddItem,
  AddItemContainer,
  CalculationContainer,
  CreateInvoiceItemContainer,
  CreateInvoiceSubTitle,
  ReorderSelectSection,
  SaveCrossSection,
  SaveSection,
  SubmitButtonContainer,
  TaxTypeButton,
  ToggleButton,
  ToggleButtonRound,
} from "../../../styledComponents/invoice";
import {
  currenciesWithSymbols,
  currencySymbolMap,
} from "../../../utils/currencies";
import AddClientPopup from "../AddClientPopup";
import InvoiceLineItemSectionEdit from "../Components/InvoiceLineItemSectionEdit";
import VisitDateComponent from "../Components/VisitDateComponent";
import SendMailPopup from "../SendMailPopup";

const EditInvoice = ({
  clearInvoiceLinkedProject,
  selectedOrganization,
  getClientList,
  location,
  getInvoiceDetails,
  getInvoiceHistory,
  invoiceDetails,
  clientList,
  createdClientId,
  callback,
  updatedInvoiceItemInfo,
  deletedInvoiceItem,
  updatedInvoiceTax,
  updatedInvoiceDiscount,
  sendInvoiceEmailInfo,
  isMailSendFromEdit,
  history,
  linkedProjectState,
  deleteInvoiceItem,
  updateInvoice,
  updateInvoiceItem,
  createInvoiceItem,
  invoiceLinkProject,
  updateInvoiceTax,
  updateInvoiceDiscount,
  isLoading,
  updateInvoiceLoading,
  clientIsLoading,
  createItemLoading,
  updateItemLoading,
  deleteItemLoading,
  linkProjectLoading,
  updateTaxLoading,
  sendMailLoading,
  updateDiscountLoading,
  createClient,
  updateInvoiceSendLog,
  createInvoiceUpdateSendLog,
  sendInvoiceEmail,
  profileData,
  jobList,
  getJobList,
  createdClientInfo,
}) => {
  const [changedInvoiceInfo, setChangedInvoiceInfo] = useState(false);

  const [selectClient, setSelectClient] = useState("");
  const [clientOptions, setClientOptions] = useState([]);

  const [invoiceNumber, setInvoiceNumber] = useState("");

  const [issuedDate, setIssuedDate] = useState(moment(new Date()));

  const [dueDate, setDueDate] = useState(null);

  const [poValue, setPoValue] = useState("");

  // Job-related states
  const [selectedJob, setSelectedJob] = useState(null);
  const [filteredJobListOptions, setFilteredJobListOptions] = useState([]);
  const [filteredJobList, setFilteredJobList] = useState([]);
  const [recurringJobList, setRecurringJobList] = useState([]);
  const [selectedVisitJobs, setSelectedVisitJobs] = useState([]);
  const [shouldLoadJobs, setShouldLoadJobs] = useState(false);
  const [isJobPreSelected, setIsJobPreSelected] = useState(false);

  const [currency, setCurrency] = useState({
    label: "USD ($) - United States Dollar",
    value: "USD",
  });

  const [itemArray, setItemArray] = useState([]);

  const [itemIndex, setItemIndex] = useState(-1);

  const [tax1, setTax1] = useState({
    percent: true,
    name: "",
    value: 0,
    isChanged: false,
  });
  const [tax2, setTax2] = useState({
    percent: true,
    name: "",
    value: 0,
    isChanged: false,
  });
  const [discount, setDiscount] = useState({
    percent: true,
    value: 0,
    isChanged: false,
  });

  const itemTypeOptions = [
    { value: "service", label: "Service" },
    { value: "product", label: "Product" },
  ];

  const [totalCalc, setTotalCalc] = useState(0);
  const [grandTotalValue, setGrandTotalValue] = useState(0);

  const [saveErrors, setSaveErrors] = useState({});

  const [popupOpen, setPopupOpen] = useState(false);
  const [sendEmailOpen, setSendEmailOpen] = useState(false);
  const [toolTipActive, setToolTipActive] = useState(-1);
  const [sentState, setSentState] = useState(false);
  const [linkedItemIndex, setLinkedItemIndex] = useState(null);
  const [createdItemindex, setCreatedItemindex] = useState(-1);

  // for tax loader
  const [loadingTaxId, setLoadingTaxId] = useState(null);

  const myRef = useRef(null);
  const executeScroll = () =>
    myRef?.current?.scrollIntoView({ behavior: "smooth" });

  useEffect(() => {
    return () => {
      clearInvoiceLinkedProject();
    };
  }, [clearInvoiceLinkedProject]);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      let payload = {
        organization_id: selectedOrganization.id,
      };
      getClientList(payload);

      if (location.search) {
        const queryParsed = queryString.parse(location.search);
        payload.invoice_id = queryParsed.id;
        getInvoiceDetails(payload);
        getInvoiceHistory(payload);
      }
    }
  }, [
    selectedOrganization,
    getClientList,
    location.search,
    getInvoiceDetails,
    getInvoiceHistory,
  ]);

  useEffect(() => {
    if (invoiceDetails && invoiceDetails.id) {
      if (invoiceDetails.client && invoiceDetails.client.id) {
        setSelectClient({
          value: invoiceDetails.client.id,
          label: invoiceDetails.client.name,
        });
      }

      setInvoiceNumber(invoiceDetails.invoice_number);
      if (invoiceDetails.po_number !== null) {
        setPoValue(invoiceDetails.po_number);
      }
      setIssuedDate(moment(invoiceDetails.issued_date));
      if (invoiceDetails.due_date !== null) {
        setDueDate(moment(invoiceDetails.due_date));
      }
      if (invoiceDetails.currency) {
        setCurrency({
          label: `${invoiceDetails.currency} (${
            currencySymbolMap[invoiceDetails.currency]
          })`,
          value: invoiceDetails.currency,
        });
      }

      if (invoiceDetails.tax1) {
        setTax1({
          percent: invoiceDetails.tax1.type === "percent" ? true : false,
          name:
            invoiceDetails.tax1.name === null ? "" : invoiceDetails.tax1.name,
          value:
            invoiceDetails.tax1.type === "percent"
              ? invoiceDetails.tax1.percent_amount
              : invoiceDetails.tax1.fixed_amount,
          isChanged: false,
        });
      }
      if (invoiceDetails.tax2) {
        setTax2({
          percent: invoiceDetails.tax2.type === "percent" ? true : false,
          name:
            invoiceDetails.tax2.name === null ? "" : invoiceDetails.tax2.name,
          value:
            invoiceDetails.tax2.type === "percent"
              ? invoiceDetails.tax2.percent_amount
              : invoiceDetails.tax2.fixed_amount,
          isChanged: false,
        });
      }
      if (invoiceDetails.discount) {
        setDiscount({
          percent: invoiceDetails.discount.type === "percent" ? true : false,
          value:
            invoiceDetails.discount.type === "percent"
              ? invoiceDetails.discount.percent_amount
              : invoiceDetails.discount.fixed_amount,
          isChanged: false,
        });
      }
      let newItems = [];
      invoiceDetails.items.map((item, index) => {
        let newItem = {};
        newItem.id = item.id;
        newItem.name = item.name;
        newItem.type = {
          value: item.type,
          label: item.type === "service" ? "Service" : "Product",
        };
        item.description !== null
          ? (newItem.description = item.description)
          : (newItem.description = "");
        newItem.quantity = item.quantity;
        newItem.unitPrice = item.unit_price;
        newItem.tax1 = item.tax1;
        newItem.tax2 = item.tax2;
        newItems.push(newItem);
      });
      itemArray &&
        itemArray.length > 0 &&
        itemArray.map((item, index) => {
          if (!item.id && createdItemindex !== index) {
            newItems.push(item);
          }
        });
      setItemArray(newItems);
    }
  }, [invoiceDetails?.id]);

  useEffect(() => {
    if (clientList && clientList.length > 0) {
      let options = [];
      clientList.map(item => {
        if (createdClientId && createdClientId === item.id) {
          setSelectClient({
            value: createdClientId,
            label: item.name,
          });
        }
        if (item.is_active) {
          options.push({
            value: item.id,
            label: item.name,
          });
        }
      });
      setClientOptions(options);
    }
  }, [clientList, createdClientId]);

  // Fetch job list when client is selected
  useEffect(() => {
    if (selectClient?.value && selectedOrganization?.id) {
      const payload = {
        client_id: selectClient.value,
        organization_id: selectedOrganization.id,
        start_date: moment().subtract(15, "days").format("YYYY-MM-DD"),
        end_date: moment().add(15, "days").format("YYYY-MM-DD"),
      };
      getJobList(payload);
      setShouldLoadJobs(true);
    } else {
      setShouldLoadJobs(false);
    }
  }, [selectClient, selectedOrganization]);

  // Filter job list: single jobs + one instance of each recurring job
  useEffect(() => {
    if (!shouldLoadJobs) {
      setFilteredJobList([]);
      setFilteredJobListOptions([]);
      return;
    }

    if (jobList?.length > 0) {
      const recurringJobCodes = new Set();
      const filtered = [];

      jobList.forEach(job => {
        if (job.code && job.recurring) {
          if (!recurringJobCodes.has(job.code)) {
            recurringJobCodes.add(job.code);
            filtered.push(job);
          }
        } else {
          filtered.push(job);
        }
      });

      setFilteredJobList(filtered);

      const jobOptions = filtered.map(job => ({
        value: job.id,
        label: job.name,
        code: job.code || null,
        recurring: job.recurring || false,
      }));

      setFilteredJobListOptions(jobOptions);
    } else {
      setFilteredJobList([]);
      setFilteredJobListOptions([]);
    }
  }, [jobList, shouldLoadJobs]);

  // Pre-select job from invoice details when filtered job list is available
  useEffect(() => {
    if (
      invoiceDetails?.job &&
      filteredJobListOptions?.length > 0 &&
      !selectedJob
    ) {
      const invoiceJobId = invoiceDetails.job;
      const matchingJob = filteredJobListOptions.find(
        job => job.value === invoiceJobId,
      );

      if (matchingJob) {
        setSelectedJob(matchingJob);
        setIsJobPreSelected(true);
      }
    }
  }, [filteredJobListOptions, invoiceDetails?.job]);

  useEffect(() => {
    totalCalculation();
  }, [itemArray]);

  useEffect(() => {
    grandTotalCalculation();
  }, [
    totalCalc,
    tax1.value,
    tax1.percent,
    tax2.value,
    tax2.percent,
    discount.value,
    discount.percent,
  ]);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      let payload = {
        organization_id: selectedOrganization.id,
      };
      getClientList(payload);
    }
  }, [createdClientId, selectedOrganization, getClientList]);

  useEffect(() => {
    if (callback) {
      setChangedInvoiceInfo(false);
    }
  }, [callback]);

  useEffect(() => {
    if (
      updatedInvoiceItemInfo !== null &&
      itemArray &&
      itemArray.length > 0 &&
      itemIndex >= 0
    ) {
      let newArray = [...itemArray];
      newArray[itemIndex].isChanged = false;
      setItemArray(newArray);
    }
  }, [updatedInvoiceItemInfo, itemArray.length, itemIndex]);

  useEffect(() => {
    if (
      deletedInvoiceItem &&
      itemArray &&
      itemArray.length > 0 &&
      itemIndex !== -1
    ) {
      let newArray = [...itemArray];
      newArray.splice(itemIndex, 1);
      setItemArray(newArray);
    }
  }, [deletedInvoiceItem, itemArray.length, itemIndex]);

  useEffect(() => {
    if (updatedInvoiceTax && updatedInvoiceTax.id && invoiceDetails) {
      if (invoiceDetails.tax1.id === updatedInvoiceTax.id) {
        setTax1(prev => ({ ...prev, isChanged: false }));
      } else if (invoiceDetails.tax2.id === updatedInvoiceTax.id) {
        setTax2(prev => ({ ...prev, isChanged: false }));
      }
    }
    setLoadingTaxId(null);
  }, [
    updatedInvoiceTax?.id,
    invoiceDetails?.tax1?.id,
    invoiceDetails?.tax2?.id,
  ]);

  useEffect(() => {
    if (updatedInvoiceDiscount !== null && discount) {
      setDiscount(prev => ({ ...prev, isChanged: false }));
    }
  }, [updatedInvoiceDiscount]);

  useEffect(() => {
    if (
      sendInvoiceEmailInfo &&
      sendInvoiceEmailInfo.log_id &&
      sentState &&
      invoiceDetails &&
      invoiceDetails.id
    ) {
      isMailSendFromEdit({ data: true });
      history.push(`/user/invoice-preview?id=${invoiceDetails.id}`);
    }
  }, [
    sendInvoiceEmailInfo,
    sentState,
    isMailSendFromEdit,
    history,
    invoiceDetails,
  ]);

  useEffect(() => {
    let newArr = [...itemArray];
    if (
      linkedProjectState &&
      linkedItemIndex !== null &&
      linkedProjectState.linked_project_id ==
        itemArray[linkedItemIndex].linkedProject.value
    ) {
      newArr[linkedItemIndex].unitPrice = parseFloat(
        linkedProjectState.unit_price,
      ).toFixed(2);
      setItemArray(newArr);
    } else if (!linkedProjectState && linkedItemIndex !== null) {
      newArr[linkedItemIndex].unitPrice = 0;
      setItemArray(newArr);
    }
  }, [linkedProjectState, linkedItemIndex, itemArray]);

  const onClientChange = e => {
    let errors = { ...saveErrors };
    delete errors["client"];
    setSaveErrors(errors);

    setSelectClient(e);
    if (!changedInvoiceInfo) {
      setChangedInvoiceInfo(true);
    }
  };

  const onInvoiceNumberChange = e => {
    setInvoiceNumber(e.target.value);
    if (!changedInvoiceInfo) {
      setChangedInvoiceInfo(true);
    }
  };

  const onIssuedDateChange = date => {
    setIssuedDate(date);
    if (!changedInvoiceInfo) {
      setChangedInvoiceInfo(true);
    }
  };

  const onDueDateChange = date => {
    setDueDate(date);
    if (!changedInvoiceInfo) {
      setChangedInvoiceInfo(true);
    }
  };

  const onPoValueChange = e => {
    setPoValue(e.target.value);
    if (!changedInvoiceInfo) {
      setChangedInvoiceInfo(true);
    }
  };

  const onCurrencyChange = e => {
    setCurrency(e);
  };

  const onJobChange = e => {
    let errors = { ...saveErrors };
    delete errors["job"];
    setSaveErrors(errors);
    setSelectedJob(e);

    if (e?.code) {
      filterRecurringJobs(e.code);
    }
  };

  const filterRecurringJobs = selectedJobCode => {
    if (!jobList || jobList.length === 0 || !selectedJobCode) {
      setRecurringJobList([]);
      return;
    }

    const tz = selectedOrganization?.timezone || moment.tz.guess();
    const today = moment().tz(tz).format("YYYY-MM-DD");

    const recurringJobs = jobList.filter(
      job => job.code === selectedJobCode && job.recurring,
    );

    const toMoment = time => (time ? moment(time + "Z").tz(tz) : null);

    const sortedJobs = recurringJobs.sort((a, b) => {
      const ma = toMoment(a.start_time);
      const mb = toMoment(b.start_time);
      if (!ma && !mb) return 0;
      if (!ma) return 1;
      if (!mb) return -1;
      return ma.diff(mb);
    });

    const todayJobs = sortedJobs.filter(job => {
      const m = toMoment(job.start_time);
      return m && m.isSame(today, "day");
    });

    const pastJobs = sortedJobs.filter(job => {
      const m = toMoment(job.start_time);
      return m && m.isBefore(today, "day");
    });

    const futureJobs = sortedJobs.filter(job => {
      const m = toMoment(job.start_time);
      return m && m.isAfter(today, "day");
    });

    const lastTwo = pastJobs.slice(-2);
    const todayJob = todayJobs.length > 0 ? [todayJobs[0]] : [];
    const upcomingTwo = futureJobs.slice(0, 2);

    const filtered = [...lastTwo, ...todayJob, ...upcomingTwo];

    setRecurringJobList(filtered);
  };

  const handleVisitDateSelect = (job, index) => {
    setSelectedVisitJobs(prev => {
      const exists = prev && prev.find(j => j && j.id === job.id);
      if (exists) {
        return prev.filter(j => j && j.id !== job.id);
      }
      return [...(prev || []), job];
    });
  };

  const onItemTypeChange = (e, index) => {
    let newArr = [...itemArray];
    newArr[index].type = e;
    if (!newArr[index].isChanged) {
      newArr[index].isChanged = true;
    }
    setItemArray(newArr);
  };

  const onItemDescChange = (e, index) => {
    let errors = { ...saveErrors };
    delete errors[`itemDescription_${index}`];
    setSaveErrors(errors);

    let newArr = [...itemArray];
    newArr[index].description = e.target.value;
    if (!newArr[index].isChanged) {
      newArr[index].isChanged = true;
    }
    setItemArray(newArr);
  };

  const onItemQuantityChange = (e, index) => {
    let errors = { ...saveErrors };
    delete errors[`itemQuantity_${index}`];
    setSaveErrors(errors);

    let newArr = [...itemArray];
    newArr[index].quantity = e.target.value;
    if (!newArr[index].isChanged) {
      newArr[index].isChanged = true;
    }
    setItemArray(newArr);
  };

  const onItemUnitPriceChange = (e, index) => {
    let errors = { ...saveErrors };
    delete errors[`itemUnitPrice_${index}`];
    setSaveErrors(errors);

    let newArr = [...itemArray];
    newArr[index].unitPrice = e.target.value;
    if (!newArr[index].isChanged) {
      newArr[index].isChanged = true;
    }
    setItemArray(newArr);
  };

  const onItemTax1Change = index => {
    let newArr = [...itemArray];
    newArr[index].tax1 = !newArr[index].tax1;
    if (!newArr[index].isChanged) {
      newArr[index].isChanged = true;
    }
    setItemArray(newArr);
    grandTotalCalculation();
  };

  const onItemTax2Change = index => {
    let newArr = [...itemArray];
    newArr[index].tax2 = !newArr[index].tax2;
    if (!newArr[index].isChanged) {
      newArr[index].isChanged = true;
    }
    setItemArray(newArr);
    grandTotalCalculation();
  };

  const onItemLinkedProjectChange = (e, index) => {
    let newArr = [...itemArray];
    newArr[index].linkedProject = e;
    newArr[index].description = e.label;
    newArr[index].quantity = 1;
    if (!newArr[index].isChanged) {
      newArr[index].isChanged = true;
    }
    setItemArray(newArr);
    setLinkedItemIndex(index);

    if (selectedOrganization && selectedOrganization.id) {
      invoiceLinkProject({
        organization_id: selectedOrganization.id,
        linked_project_id: e.value,
      });
    }
  };

  const addItemToarray = () => {
    let newArray = [...itemArray];
    let newItem = {
      type: { value: "service", label: "Service" },
      description: "",
      quantity: 0,
      unitPrice: 0,
      tax1: true,
      tax2: true,
      linkedProject: "",
      isChanged: false,
    };
    newArray.push(newItem);
    setItemArray(newArray);
  };

  const handleDeleteItem = index => {
    if (
      selectedOrganization &&
      selectedOrganization.id &&
      invoiceDetails &&
      invoiceDetails.id &&
      itemArray[index].id
    ) {
      const payload = {
        organization_id: selectedOrganization.id,
        invoice_id: invoiceDetails.id,
        item_id: itemArray[index].id,
      };

      setItemIndex(index);
      deleteInvoiceItem(payload);
    } else {
      let newArray = [...itemArray];
      newArray.splice(index, 1);
      setItemArray(newArray);
    }
  };

  const onTax1NameChange = e => {
    const currentTax1 = { ...tax1 };
    currentTax1.name = e.target.value;
    if (!tax1.isChanged) {
      currentTax1.isChanged = true;
    }
    setTax1({ ...currentTax1 });
  };
  const onTax1ValueChange = e => {
    let errors = { ...saveErrors };
    delete errors[`tax1Value`];
    setSaveErrors(errors);

    const currentTax1 = { ...tax1 };
    currentTax1.value = e.target.value;
    if (!tax1.isChanged) {
      currentTax1.isChanged = true;
    }
    setTax1({ ...currentTax1 });
  };
  const toggleTax1CalcType = value => {
    const currentTax1 = { ...tax1 };
    currentTax1.percent = value;
    if (!tax1.isChanged) {
      currentTax1.isChanged = true;
    }
    setTax1({ ...currentTax1 });
  };

  const onTax2NameChange = e => {
    const currentTax2 = { ...tax2 };
    currentTax2.name = e.target.value;
    if (!tax2.isChanged) {
      currentTax2.isChanged = true;
    }
    setTax2({ ...currentTax2 });
  };
  const onTax2ValueChange = e => {
    let errors = { ...saveErrors };
    delete errors[`tax2Value`];
    setSaveErrors(errors);

    const currentTax2 = { ...tax2 };
    currentTax2.value = e.target.value;
    if (!tax2.isChanged) {
      currentTax2.isChanged = true;
    }
    setTax2({ ...currentTax2 });
  };
  const toggleTax2CalcType = value => {
    const currentTax2 = { ...tax2 };
    currentTax2.percent = value;
    if (!tax2.isChanged) {
      currentTax2.isChanged = true;
    }
    setTax2({ ...currentTax2 });
  };

  const onDiscountValueChange = e => {
    let errors = { ...saveErrors };
    delete errors[`discountValue`];
    delete errors[`discountFixed`];
    setSaveErrors(errors);

    const currentDiscount = { ...discount };
    currentDiscount.value = e.target.value;

    if (!discount.isChanged) {
      currentDiscount.isChanged = true;
    }

    setDiscount({ ...currentDiscount });
  };

  const toggleDiscountCalcType = value => {
    const currentDiscount = { ...discount };
    currentDiscount.percent = value;

    if (!discount.isChanged) {
      currentDiscount.isChanged = true;
    }

    setDiscount({ ...currentDiscount });
  };

  const totalCalculation = () => {
    if (itemArray && itemArray.length) {
      let total = 0;
      itemArray.map(item => {
        total += item.quantity * item.unitPrice;
      });
      setTotalCalc(total.toFixed(2));
    }
  };

  const grandTotalCalculation = () => {
    const calcaulateTaxDiscount = (object, cost) => {
      if (object.percent) {
        return (object.value * cost) / 100;
      } else if (object.value) {
        return object.value;
      } else {
        return 0;
      }
    };

    if (itemArray && itemArray.length) {
      let totalTax = 0;
      itemArray.map((item, index) => {
        let itemCost = item.quantity * item.unitPrice;
        if (item.tax1) {
          totalTax += parseFloat(calcaulateTaxDiscount(tax1, itemCost));
        }
        if (item.tax2) {
          totalTax += parseFloat(calcaulateTaxDiscount(tax2, itemCost));
        }
      });

      let grandTotal =
        parseFloat(totalCalc) +
        totalTax -
        parseFloat(calcaulateTaxDiscount(discount, totalCalc));
      setGrandTotalValue(grandTotal.toFixed(2));
    }
  };

  const popupToggle = () => {
    setPopupOpen(!popupOpen);
  };

  const sendEmailToggle = () => {
    setSendEmailOpen(!sendEmailOpen);
  };

  const onSend = () => {
    setSentState(true);
  };

  const HandleSendEmail = () => {
    sendEmailToggle();

    // if (
    //   props.selectedOrganization &&
    //   props.selectedOrganization.id &&
    //   props.invoiceDetails &&
    //   props.invoiceDetails.id
    // ) {
    //   const payload = {
    //     organization_id: props.selectedOrganization.id,
    //     invoice_id: props.invoiceDetails.id,
    //   };
    //   props.createInvoiceUpdateSendLog(payload);
    // }
  };

  const checkErrorInvoice = () => {
    let formIsValid = true;
    let saveErrors = {};
    
    if (selectClient === "") {
      saveErrors["client"] = "Client can not be empty";
      formIsValid = false;
      setChangedInvoiceInfo(false);
      executeScroll();
    }

    if (!selectedJob) {
      saveErrors["job"] = "Job is required";
      formIsValid = false;
      executeScroll();
    }

    // Check that due date is not before today
    // if (dueDate) {
    //   const today = moment().startOf('day');
    //   if (dueDate.isBefore(today, 'day')) {
    //     saveErrors["dueDate"] = "Due date cannot be before today";
    //     formIsValid = false;
    //   }
    // }

    setSaveErrors(saveErrors);
    return formIsValid;
  };

  const checkErrorInvoiceItem = index => {
    let formIsValid = true;
    let newSaveErrors = { ...saveErrors };

    if (
      itemArray[index].description &&
      itemArray[index].description.length > 512
    ) {
      newSaveErrors[`itemDescription_${index}`] =
        "Item Description can have maximum 512 characters";
      formIsValid = false;
    }
    if (
      itemArray[index].quantity !== undefined &&
      itemArray[index].quantity < 1
    ) {
      newSaveErrors[`itemQuantity_${index}`] =
        "Item Quantity can't be less than 1.";
      formIsValid = false;
    }
    if (
      itemArray[index].unitPrice !== undefined &&
      itemArray[index].unitPrice < 0
    ) {
      newSaveErrors[`itemUnitPrice_${index}`] =
        "Item unit-price can't be negative.";
      formIsValid = false;
    }

    setSaveErrors(newSaveErrors);
    return formIsValid;
  };

  const checkErrorTax1 = () => {
    let formIsValid = true;
    let newSaveErrors = { ...saveErrors };

    if (tax1 && tax1.value < 0) {
      newSaveErrors["tax1Value"] = "Tax 1 value can't be negative.";
      formIsValid = false;
      setTax1({ ...tax1, isChanged: false });
    }

    setSaveErrors(newSaveErrors);
    return formIsValid;
  };

  const checkErrorTax2 = () => {
    let formIsValid = true;
    let newSaveErrors = { ...saveErrors };

    if (tax2 && tax2.value < 0) {
      newSaveErrors["tax2Value"] = "Tax 2 value can't be negative.";
      formIsValid = false;
      setTax2({ ...tax2, isChanged: false });
    }

    setSaveErrors(newSaveErrors);
    return formIsValid;
  };

  const checkErrorDiscount = () => {
    let formIsValid = true;
    let newSaveErrors = { ...saveErrors };

    if (discount && discount.percent && parseFloat(discount.value) > 100) {
      newSaveErrors["discountValue"] =
        "Discount value can't be greater than 100%.";
      formIsValid = false;
      setDiscount({ ...discount, isChanged: false });
    } else if (discount && discount.value < 0) {
      newSaveErrors["discountValue"] = "Discount value can't be negative";
      formIsValid = false;
      setDiscount({ ...discount, isChanged: false });
    } else if (
      discount &&
      !discount.percent &&
      parseFloat(discount.value) > totalCalc
    ) {
      newSaveErrors["discountFixed"] =
        "Discount can't be greater than total amount";
      formIsValid = false;
      setDiscount({ ...discount, isChanged: false });
    }

    setSaveErrors(newSaveErrors);
    return formIsValid;
  };

  const handleEditInvoice = () => {
    if (checkErrorInvoice()) {
      if (
        selectedOrganization &&
        selectedOrganization.id &&
        invoiceDetails &&
        invoiceDetails.id
      ) {
        const payload = {
          organization_id: selectedOrganization.id,
          invoice_id: invoiceDetails.id,
          client_id: selectClient.value,
          invoice_number:
            invoiceNumber === ""
              ? `${selectedOrganization.name.substring(
                  0,
                  selectedOrganization.name.indexOf(" "),
                )}_${Math.ceil(Math.random() * 10000)}`
              : invoiceNumber,
          issued_date: issuedDate.format("YYYY-MM-DD"),
          due_date: dueDate !== null ? dueDate.format("YYYY-MM-DD") : dueDate,
          po_number: poValue === "" ? null : poValue,
          currency: (currency && currency.value) || "USD",
        };

        updateInvoice(payload);
      }
    }
  };

  const handleInvoiceItem = index => {
    if (checkErrorInvoiceItem(index)) {
      if (
        selectedOrganization &&
        selectedOrganization.id &&
        invoiceDetails &&
        invoiceDetails.id
      ) {
        let payload = {
          organization_id: selectedOrganization.id,
          invoice_id: invoiceDetails.id,
          type: itemArray[index].type.value,
          description:
            itemArray[index].description === ""
              ? null
              : itemArray[index].description,
          quantity: itemArray[index].quantity,
          unit_price: itemArray[index].unitPrice,
          tax1: itemArray[index].tax1,
          tax2: itemArray[index].tax2,
          linked_project_id: !itemArray[index].linkedProject
            ? null
            : itemArray[index].linkedProject.value,
        };
        if (itemArray[index].id) {
          payload.item_id = itemArray[index].id;
          updateInvoiceItem(payload);
        } else {
          setCreatedItemindex(index);
          createInvoiceItem(payload);
        }
        setItemIndex(index);
      }
    }
  };

  const handleEditInvoiceTax1 = () => {
    if (checkErrorTax1()) {
      if (
        selectedOrganization &&
        selectedOrganization.id &&
        invoiceDetails &&
        invoiceDetails.id &&
        invoiceDetails.tax1 &&
        invoiceDetails.tax1.id
      ) {
        const payload = {
          organization_id: selectedOrganization.id,
          invoice_id: invoiceDetails.id,
          tax_item_id: invoiceDetails.tax1.id,
          tax_field: "tax1",
          type: tax1.percent ? `percent` : `fixed`,
          [tax1.percent ? `percent_amount` : `fixed_amount`]: tax1.value,
          name: tax1.name,
        };

        updateInvoiceTax(payload);
        setLoadingTaxId(invoiceDetails.tax1.id);
      }
    }
  };

  const handleEditInvoiceTax2 = () => {
    if (checkErrorTax2()) {
      if (
        selectedOrganization &&
        selectedOrganization.id &&
        invoiceDetails &&
        invoiceDetails.id &&
        invoiceDetails.tax2 &&
        invoiceDetails.tax2.id
      ) {
        const payload = {
          organization_id: selectedOrganization.id,
          invoice_id: invoiceDetails.id,
          tax_item_id: invoiceDetails.tax2.id,
          tax_field: "tax2",
          type: tax1.percent ? `percent` : `fixed`,
          [tax1.percent ? `percent_amount` : `fixed_amount`]: tax2.value,
          name: tax2.name,
        };
        updateInvoiceTax(payload);
        setLoadingTaxId(invoiceDetails.tax2.id);
      }
    }
  };

  const handleEditInvoiceDiscount = () => {
    if (checkErrorDiscount()) {
      if (
        selectedOrganization &&
        selectedOrganization.id &&
        invoiceDetails &&
        invoiceDetails.id &&
        invoiceDetails.discount &&
        invoiceDetails.discount.id
      ) {
        const payload = {
          organization_id: selectedOrganization.id,
          invoice_id: invoiceDetails.id,
          discount_id: invoiceDetails.discount.id,
          discount: {
            type: discount.percent ? `percent` : `fixed`,
            [discount.percent ? `percent_amount` : `fixed_amount`]:
              discount.value,
          },
        };

        updateInvoiceDiscount(payload);
      }
    }
  };

  return (
    <div className="content">
      {/* <PageTitle>Invoices</PageTitle> */}
      <div
        style={{
          display: `grid`,
          gridTemplateColumns: `auto`,
          justifyContent: `start`,
          marginTop: "12px",
        }}
      >
        <BackButtonComponent
          onClick={() => history.push("/user/invoices")}
          subTitle="Back to all invoices"
        />
      </div>

      {selectedOrganization && selectedOrganization.id && (
        <ClientModal
          isOpen={popupOpen}
          toggle={popupToggle}
          selectedOrganization={selectedOrganization}
          createClient={createClient}
          createdClientId={createdClientId}
          createdClientInfo={createdClientInfo}
          isClientLoading={clientIsLoading}
          setSelectedClient={setSelectClient}
          orgType={selectedOrganization?.type}
        />
      )}

      {selectedOrganization &&
        selectedOrganization.id &&
        invoiceDetails &&
        invoiceDetails.id &&
        profileData && (
          <SendMailPopup
            isOpen={sendEmailOpen}
            isLoading={sendMailLoading}
            toggle={sendEmailToggle}
            organization_id={selectedOrganization.id}
            organization_name={selectedOrganization.name}
            invoice_id={invoiceDetails.id}
            senderName={profileData.first_name}
            invoiceNumber={invoiceNumber}
            issuedDate={issuedDate.format("YYYY-MM-DD")}
            dueDate={dueDate === null ? dueDate : dueDate.format("YYYY-MM-DD")}
            email={invoiceDetails.client && invoiceDetails.client.email}
            log={updateInvoiceSendLog}
            createInvoiceUpdateSendLog={createInvoiceUpdateSendLog}
            sendInvoiceEmail={sendInvoiceEmail}
            onSend={onSend}
          />
        )}

      <ContainerNew marginTop="16px" style={{ overflowX: "auto" }} ref={myRef}>
        <PageTitle>Edit Invoice</PageTitle>
        {isLoading ? (
          <ComponentCircleLoader />
        ) : (
          <>
            <GeneralDetailsInputContainer
              style={{ minWidth: "1200px" }}
              disableResponsiveness={true}
              maxWidth="1200px"
            >
              <InputWithLabelSection alignContent="flex-start">
                <CommonGrid disableResponsive>
                  <InputLabel>
                    Customer <RedStar>*</RedStar>
                  </InputLabel>
                  {/* <AddItem
                    columns="18px auto"
                    gap="5px"
                    onClick={() => popupToggle()}
                  >
                    <img src={Plus} alt="plus" />
                    <ColoredText
                      fontSize="14px"
                      primary
                      hover
                      borderRadius="32px"
                    >
                      Add Customer
                    </ColoredText>
                  </AddItem> */}
                </CommonGrid>
                <Select
                  isSearchable
                  value={selectClient}
                  options={clientOptions}
                  placeholder="Select customer..."
                  onChange={e => {
                    onClientChange(e);
                  }}
                  styles={CreateProjectDropdown({
                    error: saveErrors["client"],
                  })}
                  isDisabled={true}
                />
                {saveErrors && saveErrors["client"] && (
                  <FormAlert>{saveErrors["client"]}</FormAlert>
                )}
              </InputWithLabelSection>

              <InputWithLabelSection alignContent="flex-start">
                <CommonGrid disableResponsive justifyContent="start" gap="4px">
                  <InputLabel margin="auto 0 0 0">Invoice Number</InputLabel>
                  <HelperIcon text="The invoice number is a unique number. You can customize this as you need." />
                </CommonGrid>
                <InputField
                  type="text"
                  placeholder="Type invoice number"
                  value={invoiceNumber}
                  onChange={e => onInvoiceNumberChange(e)}
                />
              </InputWithLabelSection>

              <InputWithLabelSection alignContent="flex-start">
                <InputLabel>
                  Issued Date <RedStar>*</RedStar>
                </InputLabel>
                <DatePicker
                  id="editIssuedDate"
                  width="100%"
                  date={issuedDate}
                  onDateChange={onIssuedDateChange}
                  placeholder={"Select issued date"}
                  allowPreviousDates
                />
              </InputWithLabelSection>

              <InputWithLabelSection alignContent="flex-start">
                <InputLabel>
                  Jobs <RedStar>*</RedStar>
                </InputLabel>
                <Select
                  isSearchable
                  // isDisabled={isJobPreSelected}
                  isDisabled={true}
                  value={selectedJob}
                  options={filteredJobListOptions}
                  placeholder="Select Job..."
                  onChange={e => {
                    onJobChange(e);
                  }}
                  styles={CreateProjectDropdown({
                    error: saveErrors["job"],
                  })}
                />
                {saveErrors && saveErrors["job"] && (
                  <FormAlert>{saveErrors["job"]}</FormAlert>
                )}
              </InputWithLabelSection>

              <InputWithLabelSection alignContent="flex-start">
                <InputLabel>Currency</InputLabel>
                <Select
                  isSearchable
                  value={currency}
                  options={currenciesWithSymbols}
                  placeholder="Select Currency..."
                  onChange={e => {
                    onCurrencyChange(e);
                    if (!changedInvoiceInfo) {
                      setChangedInvoiceInfo(true);
                    }
                  }}
                  styles={CreateProjectDropdown({
                    error: saveErrors["currency"],
                  })}
                />
                {saveErrors && saveErrors["currency"] && (
                  <FormAlert>{saveErrors["currency"]}</FormAlert>
                )}
              </InputWithLabelSection>

              <InputWithLabelSection alignContent="flex-start">
                <InputLabel>Due Date</InputLabel>
                <DatePicker
                  id="editDueDate"
                  width="100%"
                  date={dueDate}
                  onDateChange={onDueDateChange}
                  placeholder={"Select due date"}
                  allowPreviousDates
                />
              </InputWithLabelSection>
            </GeneralDetailsInputContainer>

            {changedInvoiceInfo && (
              <ColoredButtonWithIcon
                type="orange"
                onClick={handleEditInvoice}
                disabled={updateInvoiceLoading}
                width="120px"
              >
                {updateInvoiceLoading ? "Saving..." : "Save"}
              </ColoredButtonWithIcon>
            )}

            {recurringJobList?.length > 0 && (
              <InputWithLabelSection>
                <InputLabel>Visit Date</InputLabel>
                <CommonGrid
                  disableResponsive
                  columns="repeat(8, 1fr)"
                  gap="10px"
                >
                  {recurringJobList.map((job, index) => (
                    <VisitDateComponent
                      job={job}
                      key={index}
                      index={index}
                      visitDateSelect={handleVisitDateSelect}
                    />
                  ))}
                </CommonGrid>
              </InputWithLabelSection>
            )}

            <InvoiceLineItemSectionEdit
              currency={currency?.value}
              createInvoiceItem={createInvoiceItem}
              updateInvoiceItem={updateInvoiceItem}
              deleteInvoiceItem={deleteInvoiceItem}
              updateInvoiceTax={updateInvoiceTax}
              updateInvoiceDiscount={updateInvoiceDiscount}
              invoiceDetails={invoiceDetails}
              selectedOrganization={selectedOrganization}
            />

            <CommonGrid
              margin="20px 0 40px 0"
              gap="12px"
              columns="auto auto"
              justifyContent="flex-start"
              disableResponsive
            >
              <PrimaryBgButton
                padding={sendMailLoading ? "0 30px" : "0 40px"}
                onClick={() => HandleSendEmail()}
                disabled={sendMailLoading}
              >
                {sendMailLoading ? (
                  <ButtonTextLoader loadingText="Sending" fontSize="13px" />
                ) : (
                  "Send Invoice"
                )}
              </PrimaryBgButton>

              <PrimaryWhiteBgButton
                padding={updateInvoiceLoading ? "0 30px" : "0 40px"}
                onClick={() =>
                  invoiceDetails && invoiceDetails.id
                    ? history.push(
                        `/user/invoice-preview?id=${invoiceDetails.id}`,
                      )
                    : null
                }
                disabled={updateInvoiceLoading || !invoiceDetails?.id}
              >
                {updateInvoiceLoading ? (
                  <ButtonTextLoader loadingText="Loading" fontSize="13px" />
                ) : (
                  "Save As Draft"
                )}
              </PrimaryWhiteBgButton>
            </CommonGrid>
          </>
        )}
      </ContainerNew>
    </div>
  );
};

export default EditInvoice;
